import { render } from "./DropdownSingle.vue?vue&type=template&id=2c56523c&scoped=true"
import script from "./DropdownSingle.vue?vue&type=script&lang=js"
export * from "./DropdownSingle.vue?vue&type=script&lang=js"

import "./DropdownSingle.vue?vue&type=style&index=0&id=2c56523c&scoped=true&lang=css"

import exportComponent from "/chi/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c56523c"]])

export default __exports__